import srb from './translations/srb.json'
import eng from './translations/eng.json'

export default {
    srb, eng
}